
export default function ListenGuideSection() {
  const podcastPlatforms = [
    {
      name: 'Spotify',
      icon: 'ri-spotify-line',
      color: '#1DB954',
      url: 'https://open.spotify.com/show/0c9MMP8LeJ2GOECaXBCQw9?si=NeK7QlZ8TyyTobKUrS6odg'
    },
    {
      name: 'Amazon Music',
      icon: 'ri-amazon-line',
      color: '#FF9900',
      url: 'https://music.amazon.co.jp/podcasts/2a601e54-0748-4cd6-b853-e735ab57f9ee/windies-mania-shabadaba'
    },
    {
      name: 'Apple Podcasts',
      icon: 'ri-apple-line',
      color: '#A855F7',
      url: 'https://podcasts.apple.com/jp/podcast/windies-mania-shabadaba/id1507954688'
    }
  ];

  return (
    <section id="listen" className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#ff1493]/5 to-transparent"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            聴き方ガイド
          </h3>
          <div className="w-24 h-1 bg-[#ff1493] mx-auto rounded-full mb-6"></div>
          <p className="text-white/70 text-lg">
            お好きな方法で番組をお楽しみください
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-[#ff1493]/50 transition-all duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#ff1493] rounded-2xl">
                <i className="ri-radio-2-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-white">ラジオで聴く</h4>
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              コミュニティFMで毎週火曜日18:30から放送中。お住まいの地域で以下の周波数に合わせてお聴きください。
            </p>
            <div className="bg-[#ff1493]/20 backdrop-blur-sm p-6 rounded-xl border border-[#ff1493]/30">
              <p className="text-white/70 text-sm mb-2">周波数</p>
              <p className="text-[#ff1493] text-4xl font-bold">83.6 MHz</p>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-[#00d9ff]/50 transition-all duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#00d9ff] rounded-2xl">
                <i className="ri-global-line text-3xl text-[#0a1628]"></i>
              </div>
              <h4 className="text-2xl font-bold text-white">サイマルラジオで聴く</h4>
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              インターネット経由でラジオを聴けます。全国どこからでもリアルタイムで視聴可能です。
            </p>
            <a 
              href="https://www.jcbasimul.com/ulalafm" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#00d9ff]/20 hover:bg-[#00d9ff]/30 text-[#00d9ff] px-6 py-3 rounded-xl border border-[#00d9ff]/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <span>サイマルラジオへ</span>
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-[#ffd700]/50 transition-all duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#ffd700] rounded-2xl">
                <i className="ri-headphone-line text-3xl text-[#0a1628]"></i>
              </div>
              <h4 className="text-2xl font-bold text-white">ポッドキャストで聴く</h4>
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              いつでもどこでも好きな時間に。各種ポッドキャストプラットフォームで配信中です。
            </p>
            <div className="flex items-center gap-3">
              <i className="ri-time-line text-[#ffd700] text-xl"></i>
              <p className="text-white/70 text-sm">24時間いつでも視聴可能</p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/10">
          <h4 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center">
            ポッドキャスト配信プラットフォーム
          </h4>
          <div className="grid md:grid-cols-3 gap-6">
            {podcastPlatforms.map((platform, index) => (
              <a
                key={index}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-white/30 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
              >
                <div className="flex flex-col items-center text-center">
                  <div 
                    className="w-20 h-20 flex items-center justify-center rounded-2xl mb-4 transition-all duration-300 group-hover:scale-110"
                    style={{ backgroundColor: `${platform.color}20` }}
                  >
                    <i 
                      className={`${platform.icon} text-4xl`}
                      style={{ color: platform.color }}
                    ></i>
                  </div>
                  <h5 className="text-xl font-bold text-white mb-2 whitespace-nowrap">{platform.name}</h5>
                  <p className="text-white/60 text-sm mb-4 whitespace-nowrap">今すぐ聴く</p>
                  <div className="flex items-center gap-2 text-white/50 group-hover:text-[#ff1493] transition-colors">
                    <span className="text-sm whitespace-nowrap">配信中</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
